import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FilterService } from './filter.service';
import { QueryParamStateService } from './query-param-state.service';
import { FilterName } from './filter-name';

@Injectable({ providedIn: 'root' })
export class FilteringTekstService {
	private readonly router = inject(Router);
	private readonly filterService = inject(FilterService);
	private readonly qp = inject(QueryParamStateService);

	bepaalFilteringTekst(url: string): string {
		const negeerParams = new Set(this.qp.getAllQueryParamOptions());
		const queryParamMap = this.router.parseUrl(url).queryParamMap;

		const onderdelen: string[] = [];
		for (const key of queryParamMap.keys) {
			if (negeerParams.has(key)) continue;

			const config = this.filterService.configs[<FilterName>key];
			if (!config) continue;

			const decoded = config.decode(queryParamMap.get(key)!);
			if (decoded === undefined || decoded === null) continue;

			const tekst = config.valueString(decoded);
			if (tekst) onderdelen.push(tekst);
		}

		return onderdelen.join(', ');
	}
}
